import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import FormInput from '../../nuup/componentes/Forms/FormInput';
import Api from '../../api/global.service';
import Swal from 'sweetalert2';
import generalSuccessModal from '../modal/modal-success';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FooterButtons from '../modal/footer-buttons';

const NameForm = ({
  nombresOriginal,
  apellidoPaterno,
  apellidoMaterno,
  columnLabel,
  column,
  idCuenta,
  onClose,
  showModal,
  setData,
  maxChar = 255,
}) => {
  let schema = yup.object().shape({
    nombres: yup
      .string()
      .max(maxChar, `Máximo ${maxChar} caracteres`)
      .required('No se puede enviar un campo vacío'),
    apellido_paterno: yup
      .string()
      .max(maxChar, `Máximo ${maxChar} caracteres`)
      .required('No se puede enviar un campo vacío'),
    apellido_materno: yup
      .string()
      .max(maxChar, `Máximo ${maxChar} caracteres`)
      .required('No se puede enviar un campo vacío'),
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onBlur',
    defaultValues: {
      nombres: nombresOriginal,
      apellido_paterno: apellidoPaterno,
      apellido_materno: apellidoMaterno,
    },
  });

  useEffect(() => {
    reset({
      nombres: nombresOriginal,
      apellido_paterno: apellidoPaterno,
      apellido_materno: apellidoMaterno,
    });
    schema = yup.object().shape({
      nombres: yup
        .string()
        .max(maxChar, `Máximo ${maxChar} caracteres`)
        .required('No se puede enviar un campo vacío'),
      apellido_paterno: yup
        .string()
        .max(maxChar, `Máximo ${maxChar} caracteres`)
        .required('No se puede enviar un campo vacío'),
      apellido_materno: yup
        .string()
        .max(maxChar, `Máximo ${maxChar} caracteres`)
        .required('No se puede enviar un campo vacío'),
    });
  }, [showModal]);

  const onSubmit = values => {
    setLoading(true);
    const payload = {
      ...values,
      id_cuenta: idCuenta,
      column: column,
    };

    Api.create(`admin/sic/padron_edit/${column}`, payload)
      .then(response => {
        const { success, message, data } = response.data;
        const finish = () => {
          if (setData) {
            setData({
              fullname: values.nombres + ' ' + values.apellido_paterno + ' ' + values.apellido_materno,
              nombres: values.nombres,
              apellido_paterno: values.apellido_paterno,
              apellido_materno: values.apellido_materno,
            });
          } else {
            history.go(0);
          }
          setLoading(false);
          onClose();
        };
        generalSuccessModal(success, `${columnLabel} actualizado con éxito`, finish, message, data);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log('error', error);
        const err = error.response.data;
        const errorMessage = err.errors['new_value'] !== undefined ? err.errors['new_value'] : err.errors.message;
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: '',
          text: errorMessage,
        });
      });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div className="modal-body">
        <div className="row my-4">
          <h4
            style={{
              textAlign: 'center',
              width: '100%',
            }}>
            {columnLabel}
          </h4>
          <div className="col-12">
            <h6 style={{ marginBottom: '-5px', marginTop: '15px' }}>Nombres</h6>
            <FormInput
              id="nombres"
              type="text"
              name="nombres"
              // label={columnLabel}
              error={errors.nombres}
              register={register}
            />
          </div>
          <div className="col-12">
            <h6 style={{ marginBottom: '-5px', marginTop: '15px' }}>Apellido Paterno</h6>
            <FormInput
              id="apellido_paterno"
              type="text"
              name="apellido_paterno"
              // label={columnLabel}
              error={errors.apellido_paterno}
              register={register}
            />
          </div>
          <div className="col-12">
            <h6 style={{ marginBottom: '-5px', marginTop: '15px' }}>Apellido Materno</h6>
            <FormInput
              id="apellido_materno"
              type="text"
              name="apellido_materno"
              // label={columnLabel}
              error={errors.apellido_materno}
              register={register}
            />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        {loading && (
          <div className="spinner-border text-warning" role="status">
            <span className="sr-only">Guardando...</span>
          </div>
        )}
        {!loading && <FooterButtons onClose={onClose} />}
      </div>
    </form>
  );
};

export default NameForm;
